import styled from "@emotion/styled";
import { type MouseEventHandler, type PropsWithChildren, useCallback } from "react";

import { useIsNodeSelected, useSetSelectedNodeId } from "./useSelectedNode";

const Container = styled.div<{ $selected: boolean }>`
  border: solid 2px ${({ $selected, theme }) => ($selected ? theme.primary : "transparent")};
  border-radius: ${({ theme }) => theme.borderRadius + 1}px;

  transition: border-color 200ms ease-in-out;
`;

type NodeSelectionWrapperProps = PropsWithChildren<{
  nodeId: number;
}>;

export const NodeSelectionWrapper = ({ nodeId, children }: NodeSelectionWrapperProps) => {
  const isSelected = useIsNodeSelected(nodeId);
  const setSelectedNodeId = useSetSelectedNodeId();

  const handleClick: MouseEventHandler = useCallback(
    (e) => {
      e.stopPropagation();
      setSelectedNodeId(nodeId);
    },
    [nodeId, setSelectedNodeId],
  );

  return (
    <Container $selected={isSelected} onClick={handleClick} onDoubleClick={handleClick}>
      {children}
    </Container>
  );
};
